<script setup>
import CFInlineSpinner from '@/ui/Spinner/CFInlineSpinner.vue';

defineOptions({
    inheritAttrs: false,
});

defineProps({
    id: {
        type: String,
        default: undefined,
    },
    label: {
        type: String,
        default: undefined,
    },
    placeholder: {
        type: String,
        default: undefined,
    },
    rows: {
        type: Number,
        default: 4,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    invalid: {
        type: Boolean,
        default: false,
    },
});

const model = defineModel({ type: String, default: null });
</script>

<template>
    <div
        class="relative border-b bg-white p-3 focus-within:border-b-black"
        :class="{
            'border-transparent': !invalid,
            'border-b-red-500': invalid,
        }"
    >
        <label
            v-if="label"
            :for="id"
            class="text-2xs block leading-none font-bold text-black"
        >
            {{ label }}
        </label>
        <textarea
            :id="id"
            v-bind="$attrs"
            v-model="model"
            :readonly="readonly || loading"
            :placeholder="placeholder"
            :rows="rows"
            class="placeholder:text-neutrals-600 mt-0.5 block w-full border-0 p-0 text-sm text-black focus:ring-0 focus:outline-0"
        />
        <span
            v-if="loading"
            role="status"
            class="absolute top-3 right-3 z-10 flex items-center"
        >
            <CFInlineSpinner size="sm" />
            <span class="sr-only">{{ $t('general.loading') }}...</span>
        </span>
    </div>
</template>
